import { render } from "./UserSetting.vue?vue&type=template&id=6bdb9413"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"

import "./UserSetting.vue?vue&type=style&index=0&id=6bdb9413&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__